function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__ic_camera_filled-a",
  d: "M12 9.75c-1.823 0-3.3 1.512-3.3 3.375S10.177 16.5 12 16.5c1.822 0 3.3-1.512 3.3-3.375S13.822 9.75 12 9.75zm8.8-3.375h-2.64c-.363 0-.755-.288-.868-.641L16.61 3.64c-.116-.352-.505-.64-.869-.64H8.26c-.363 0-.755.288-.868.639l-.684 2.095c-.115.353-.505.641-.868.641H3.2c-1.21 0-2.2 1.013-2.2 2.25V18.75C1 19.988 1.99 21 3.2 21h17.6c1.21 0 2.2-1.012 2.2-2.25V8.625c0-1.237-.99-2.25-2.2-2.25zM12 18.75c-3.038 0-5.5-2.518-5.5-5.625S8.962 7.5 12 7.5c3.037 0 5.5 2.518 5.5 5.625S15.037 18.75 12 18.75zm8.25-8.775a.78.78 0 0 1-.77-.789.78.78 0 0 1 .77-.787c.426 0 .77.353.77.787a.78.78 0 0 1-.77.789z"
}));

var _ref3 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__ic_camera_filled-a"
});

var SvgIcCameraFilled = function SvgIcCameraFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCameraFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_camera_filled.c577d8bf.svg";
export { ForwardRef as ReactComponent };